var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.678 2.81c0 .34.275.615.615.615h5.793a.615.615 0 1 0 0-1.23H6.293a.615.615 0 0 0-.615.615zM2.807.554v4.102H1.576V1.128h-.82v-.82h2.05v.246zM.217 10.742 2.34 8.07h-.01a.492.492 0 1 0-.853 0H.183a1.64 1.64 0 1 1 3.277 0c-.04.332-.132.602-.274.81-.143.209-.484.568-1.02 1.077h1.297v.82H.18l.036-.035zm6.076-3.164h5.793a.615.615 0 0 1 0 1.23H6.293a.615.615 0 0 1 0-1.23z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/ordered-list.74d62dec66965f0f2d4b7adad5b4ce21.svg";
export { ForwardRef as ReactComponent };